<div class="input-link">
  @if (isMultiValueLink) {
    <!-- multi value link -->
    @for (linkedRecord of linkedRecords; track linkedRecord.value) {
      <div class="linked-record">
        <span>
          {{ linkedRecord.linkRecordDisplayValue }}
        </span>
        @if (!column.isComputed) {
          <mat-icon
            svgIcon="icon_close_16"
            (click)="setOrRemoveLinkedRecord(linkedRecord)"
            (keyDown.enter)="setOrRemoveLinkedRecord(linkedRecord)"
          />
        }
      </div>
    }
    @if (!column.isComputed) {
      <div
        #linkAddButton
        data-cy="FieldInput:Link:Add"
        tabindex="0"
        class="add-icon"
        [class.disabled]="isDisabled"
        [matMenuTriggerFor]="findRecordMenu"
        #menuTriggerAdd="matMenuTrigger"
        (menuOpened)="setRecordMenuTrigger(menuTriggerAdd)"
      >
        <mat-icon svgIcon="icon_add_32" />
      </div>
    }
  } @else {
    <!-- single value link -->
    @let linkedRecord = linkedRecords[0];
    @if (!linkedRecord?.value && !column.isComputed) {
      <div
        data-cy="FieldInput:Link:Add"
        #linkAddButton
        tabindex="0"
        class="add-icon"
        [class.disabled]="isDisabled"
        [matMenuTriggerFor]="findRecordMenu"
        #menuTriggerAdd="matMenuTrigger"
        (menuOpened)="setRecordMenuTrigger(menuTriggerAdd)"
      >
        <mat-icon svgIcon="icon_add_32" />
      </div>
    } @else {
      <div class="linked-record">
        <span>
          {{ linkedRecord.linkRecordDisplayValue }}
        </span>
        @if (!column.isComputed) {
          <mat-icon
            data-cy="FieldInput:Link:Remove"
            svgIcon="icon_close_16"
            (click)="setOrRemoveLinkedRecord(linkedRecord)"
            (keyDown.enter)="setOrRemoveLinkedRecord(linkedRecord)"
          />
        }
      </div>
    }
  }

  <mat-menu #findRecordMenu="matMenu" [class]="'find-record-menu'">
    <ng-template matMenuContent>
      <div (click)="$event.stopPropagation()">
        <blaze-find-record-panel
          [menuOpened$]="recordMenuOpened$.asObservable()"
          [selectedRecord]="linkedRecords[0]"
          [selectedRecords]="linkedRecords"
          [columns]="columns"
          (recordSelected)="setOrAddLinkedRecord($event)"
          (closePanel)="recordMenuTrigger.closeMenu()"
          [link]="column.link"
        />
      </div>
    </ng-template>
  </mat-menu>
</div>
